/*
This one is usually called helpers.js and the goal of this file or of this module is to contain a couple of functions that we reuse over and over in our project.

So in this module we then have a central place for all of them basically.

*/
// import axios from 'axios';
import { TIMEOUT_SEC } from './config';

const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};

export const AJAX = async (crud, url, uploadData = undefined) => {
  //   create: post, read: get, delete: delete, update: patch

  try {
    let fetchPro;
    if (crud === 'postProduct') {
      fetchPro = fetch(url, {
        method: 'POST',

        withCredentials: true, // it will send cookie from browser to server
        credentials: 'include', // it will set cookie in browser coming from server

        body: uploadData,
        // We are using multer on server side for this route i.e. no need to send json data.
      });
    }

    if (crud === 'patchProduct') {
      fetchPro = fetch(url, {
        method: 'PATCH',

        withCredentials: true, // it will send cookie from browser to server
        credentials: 'include', // it will set cookie in browser coming from server

        body: uploadData,
        // We are using multer on server side for this route i.e. no need to send json data.
      });
    }

    if (crud === 'post') {
      fetchPro = fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'Content-Type':
          //   'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
          // 'Content-Type': 'application/x-www-form-urlencoded',
          // Accept:
          //   'application/json, application/xml, text/plain, text/html, *.*',
          // 'Content-Type': 'multipart/form-data',
        },
        withCredentials: true, // it will send cookie from browser to server
        credentials: 'include', // it will set cookie in browser coming from server
        body: JSON.stringify(uploadData),
      });
    }

    if (crud === 'get') {
      fetchPro = fetch(url, {
        method: 'GET',
        // headers: {
        //   'Content-Type': 'application/json',
        // },
        withCredentials: true,
        credentials: 'include',
      });
    }

    if (crud === 'patch') {
      fetchPro = fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true, // it will send cookie from browser to server
        credentials: 'include', // it will set cookie in browser coming from server
        body: JSON.stringify(uploadData),
      });
    }

    const res = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);

    const data = await res.json();

    if (!res.ok) throw new Error(`${data.message} (${res.status})`);
    return data;
  } catch (err) {
    throw err;
  }
};

export const printdDate = (date, time = false) => {
  if (!time) {
    return new Intl.DateTimeFormat(navigator.language, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }).format(new Date(date));
  }
  if (time) {
    return new Intl.DateTimeFormat(navigator.language, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(date));
  }
};

export const capitalize = str => {
  return str.trim().includes(' ')
    ? str
        .split(' ')
        .map(el => {
          return `${el.at(0).toUpperCase()}${el.slice(1).toLowerCase()}`;
        })
        .join(' ')
    : `${str.trim().at(0).toUpperCase()}${str.trim().slice(1).toLowerCase()}`;
};
